const LEVELS = [
  {
    id: "Very High",
    name: "Very High",
    value: "Very High",
  },
  {
    id: "High",
    name: "High",
    value: "High",
  },
  {
    id: "Moderate",
    name: "Moderate",
    value: "Moderate",
  },
  {
    id: "Low",
    name: "Low",
    value: "Low",
  },
  {
    id: "Very Low",
    name: "Very Low",
    value: "Very Low",
  },
];

export default LEVELS;
